// src/hooks/useAuth.ts
import { useEffect, useCallback } from 'react';
import Cookies from 'js-cookie';
import {
  login as loginService,
  logout as logoutService,
  logoutAllDevices as logoutAllDevicesService,
} from '../stateManagers/services/authService';
import { useAuthStore } from '../stateManagers/store/authStore';

export const useAuth = () => {
  const {
    isAuthenticated,
    user,
    accessToken,
    refreshToken,
    loading,
    clearAuth,
    initAuth,
  } = useAuthStore();

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  const login = useCallback(async (username: string, password: string) => {
    try {
      const response = await loginService(username, password);

      const savedAccessToken = Cookies.get('accessToken');
      const savedRefreshToken = Cookies.get('refreshToken');

      if (!savedAccessToken || !savedRefreshToken) {
        throw new Error('Failed to save authentication tokens');
      }

      initAuth();
      return response;
    } catch (error: any) {
      const message = error.response?.data?.message || error.message || 'Login failed';
      throw new Error(message);
    }
  }, [initAuth]);

  const logout = useCallback(async () => {
    try {
      if (accessToken && refreshToken) {
        await logoutService(accessToken, refreshToken);
      }
    } finally {
      clearAuth();
    }
  }, [accessToken, refreshToken, clearAuth]);

  const logoutAll = useCallback(async () => {
    try {
      if (accessToken) {
        await logoutAllDevicesService(accessToken);
      }
    } finally {
      clearAuth();
    }
  }, [accessToken, clearAuth]);

  return {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
    logoutAll,
  };
};